import React from "react";
import { ModalWrapper } from "../Modal/Modal";

import { connector, ContainerProps } from "./containers/Loader.container";

export type LoaderProps = {
  isFetching: boolean;
};

export const LoaderWrapper: React.FC<LoaderProps> = ({ isFetching }) => {
  return (
    <ModalWrapper
      isOpen={isFetching}
      type="loader"
      title="Chargement en cours"
      content="Le haïku est en train d'être publié"
    />
  );
};

export const LoaderContainer: React.FC<ContainerProps> = (props) => (
  <LoaderWrapper {...props} />
);

export const Loader = connector(LoaderContainer);
